<template>
	<div>
		<b-input-group class="mb-3">
			<b-form-input
				ref="input"
				:state="state"
				type="text"
				placeholder="pp.kk.vvvv"
				autocomplete="off"
				:value="formattedDate"
				@update="handleDateInput"
				lazy
				trim
			></b-form-input>
			<b-input-group-append>
				<b-form-datepicker
					v-model="date"
					button-only
					button-variant="primary"
					right
					locale="fi"
					@context="onContext"
					v-bind="labels.fi"
					:show-decade-nav="true"
					:date-format-options="{
						year: 'numeric',
						month: '2-digit',
						day: '2-digit',
						weekday: 'short'
					}"
				></b-form-datepicker>
			</b-input-group-append>
		</b-input-group>
		<b-alert v-if="error" show variant="warning">{{ error }}</b-alert>
	</div>
</template>

<script>
import { format, parseISO, parse, isValid } from "date-fns";
export default {
	props: ["value", "state"],
	data() {
		return {
			dateInput: null,
			error: null,
			labels: {
				fi: {
					labelPrevDecade: "Aikaisempi vuosikymmen",
					labelPrevYear: "Aikaisempi vuosi",
					labelPrevMonth: "Aikaisempi kuukausi",
					labelCurrentMonth: "Nykyinen kuukausi",
					labelNextMonth: "Seuraava kuukausi",
					labelNextYear: "Seuraava vuosi",
					labelNextDecade: "Sseuraava vuosikymmen",
					labelToday: "Tänään",
					labelSelected: "Valittu päivämäärä",
					labelNoDateSelected: "Ei päivämäärää valittuna",
					labelCalendar: "Kalenteri",
					labelNav: "Kalenterin navigointi",
					labelHelp: "Selaa kalenteria nuolinäppäimillä"
				}
			}
		};
	},
	computed: {
		date: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit("input", newVal);
			}
		},
		formattedDate() {
			if (!isValid(parseISO(this.value, "yyyy-MM-dd"))) {
				return null;
			}
			return format(parseISO(this.value, "yyyy-MM-dd"), "dd.MM.yyyy");
		}
	},
	methods: {
		handleDateInput(dateString) {
			let parsed = parse(dateString, "dd.MM.yyyy", new Date());

			if (isValid(parsed)) {
				this.$emit("input", format(parsed, "yyyy-MM-dd"));
				this.error = null;
			} else {
				this.error = "Päivämäärän pitää olla muotoa pp.kk.vvvv (esim. 31.12.2020)";
				this.$refs.input.$el.value = null;
				this.$emit("input", null);
			}
		},
		onContext(ctx) {
			if (!ctx.selectedYMD) {
				return;
			}

			this.error = null;

			this.$emit("input", ctx.selectedYMD);
		}
	}
};
</script>

<style lang="scss" scoped></style>
